import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import date from "date-and-time";
import ordinal from "date-and-time/plugin/ordinal";
import { IDashboardStats } from "../../models/DashboardStats";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "bottom",
    },
    title: {
      display: false,
      text: "Chart.js Line Chart",
    },
  },
  interaction: {
    intersect: false,
    mode: "index",
  },
  scales: {
    y: {
      grid: { display: false },
    }
  }
};

date.plugin(ordinal);

const d = new Date();

// const labels = Array(30)
//   .fill("")
//   .map((_, i) => new Date(new Date().setDate(new Date().getDate() - (i + 1))),)
//   .reverse();

const labels = Array(30)
  .fill("")
  .map((_, i) => {
    const date = new Date();
    date.setDate(date.getDate() - (i + 1));
    return date;
  })
  .filter(date => {
    const day = date.getDay();
    return day !== 0 && day !== 6; // 0 = Sunday, 6 = Saturday
  })
  .reverse();



export default function Generic30DayGraph({ datasets, LineTension = 0.4 }) {
  const data = {
    labels: labels.map((day) => date.format(new Date(day), "ddd DD")),
    datasets: 
      datasets.map((dataset, index) => ({
        label: dataset.label,
        data: labels.map((day) => dataset.data[date.format(new Date(day), "DD/MM/YYYY")]),
        borderColor: dataset.borderColor,
        backgroundColor: dataset.backgroundColor,
        lineTension: LineTension,
      })),
  };


  return <Line options={options} data={data} />;
}
